<template>
  <div id="center" class="clearfix" style="min-height: 246px">
    <div id="left-menu" class="pull-left">
      <i class="iconfont m-show-btn mhide"></i>
      <div class="menu-wrap">
        <i class="iconfont close-leftmenu-btns mhide"></i>
        <div class="t-user t-teacher-box">
          <img
            :src="this.$store.state.headPortrait"
            onerror="this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAE90lEQVRogdWbTWgdVRTHf3PfVxbWCFahRoTulFJELRVLrc8aFy5trYW6luLHtttSu5SCC7Eu3IpiStuVaBfamlaCUkF4dmtBqmIwJa2FfMybuS5O7nSSzJt5M/fMS/KDLPLevHPPf+73OfcGCwsL1MQ48AKwB9gF7AQmgIeAB1aeuQfMA38BvwM3gOvADHCnDqcCZcGPA0eBQ8DzQKOinQj4CbgAnAP+UPEOPcEHgBPAa1QXOYgI+AY4A/zga8xXcBc4Dbzo68iQXAVOAleqGjAVf7cD+By4zOjEslLW5ZWyd1QxUKWGjwCfIYPSRnIHeBvp40NTpobbwMfAFBsvFsSHKcSnzrA/GraGtwEXgVcquVY/08DrwO2iB4ep4UeQfrNZxYLMEt8jvuZSJHgc+BZ4TsGpunkauERBd8sT3EYm/mcVnaqbZxCf24MeyBP8EXBQ26MRcBDxPZNBg9YRZATcyhwlQ0OW4AngN2SRr0Icx8mftRZrrRQeBAAYYwiCgEajkXymwDywG7iV/jBL8AVkiC9NFEWJKEda4DAYY2g0GjQaKkvyi8hGJmGt4JeR4b0Si4uLVX+6DmMMrVZLo8Ynge8Su2u+PO1jWbE5Escxy8vLpVrHAE6l/0kLPgDs97GsKRikOyiI3o9oA1YLPuFjNQxD4jj2MZGJtZZ+v+9rJtHm+vCjwJ9As4o11/zqpNPp+LSgPjL7zLoaPkZFsUAtNatcRhPRmDTpw74O1Y3CSz0M0qTHgTk8YlFhGBJFka9DuRhjaLcHLpGHIQIeNsA+PANv2qNzTWU0gH2GLbIbUnqpewyy3vRii9QwwC6DZAS82EKCdxrgMV8rCsu/QpSmvgmD5zYwjmPCMNRwJpd+v68h+kHD/cTWpkehJW2rmnnYEBT68bJBUpYb6cQouWeQUEhlRinYGO8G+Z9BktEb7cioyvjHADd9rTSbzVprOggCms3Km7k0Nw0SofTCGEOn06mlppVt3zDALxqWAK1I4yqUX+J1le1hmqWlJdWVl2ekI00EbDdIYnlGwyJAq9XSMqUVpnXMAPOuvZzXsuo26r6ONptN7S5yHpSCeFlYa4miqHTE0Y3IymLXBfFmkdyqGs7xsbGxoWs7CAI6nU4dg98lROOquPSH2qVsIhJtacHTwLU6SitTwzVwDdEGrM8tndIsyVpbKiPh9tbKce4P0v+opksdURQlqdOquHyxZ864MF0KckC0R8lISBzHiVBtXM7YJc6HJDMhnjUN3QKOA1/lWUsnv+tOtbjTAyA1b4xJXkIOx1kjFvIPpp0F3kl/4ObWKIpGErgrwjX7jJ3Up8C7mb/JEdxG5q8u3B9QNoPQtQRBQKvVchuNaeBVIDOdmbcVWQbeAHqK2fhacInzOI57yCA1MHdbtPeas9ZOhmH4q6qH9dALw3DSWjuX91DhZrPf789aa19CzltuVq4CXWvtbNHaPVewG6SAu8jx/k+0PFTkLNJnbwOFA2qu4DXTzRLwPvAmNd04KcldxJf3EN8S8qbJMoId54CngC/KeqjIl8CTDDgNry0Y4G/gLeQgWy0bjgH8iBwePbbiQyaVBQ8xDV1BLl50ga+BOpZc8YrtLnLmqnDwzPM79wpAhYDcE0i/OgTsxe+i1s/IRmaKkhe1XCAh87s8wS5EU3HBkb6KtxtJvG8n+yrev0hCoIfnVbyiENH/d4LwXx+Ezr4AAAAASUVORK5CYII='"
            width="36"
            height="36"
          /><span class="center-name">{{ this.$store.state.userName }}</span>
          <!--../assets/image/user.png-->
          <!-- <span class="center-auth auth-2">未认证</span> -->
        </div>
        <ul class="my-left">
          <li class="m-li1">
            <i class="iconfont icon-wode"></i>
            <router-link to="/teachersPersonalCenter">我的信息</router-link>
          </li>
          <li class="m-li2">
            <i class="iconfont icon-chugui2"></i>
            <router-link to="/personalCenterChangePasswords">修改密码</router-link>
          </li>
          <li class="m-li3">
            <i class="iconfont icon-star-hollow"></i>
            <router-link to="/myCollection">我的收藏</router-link>
          </li>

          <li class="m-li4">
            <i class="iconfont icon-555"></i>

            <router-link to="/myComments">我的评论</router-link>
          </li>

          <li class="m-li8 cur">
            <i class="iconfont icon-555"></i>

            <router-link to="/myExperiment">我的实验</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div id="content" class="pull-right">
      <div class="center_content" style="min-height: 533.6px">
        <div class="content-wrap clearfix">
          <!-- <form id="searchSection" onsubmit="return false;">
            <input type="text" class="s-input" name="title" placeholder="项目名称" />
            <input type="button" class="s-btn" value="搜索" />
          </form> -->
          <ul id="list" class="clearfix">
            <li
              class="clearfix"
              v-for="(item, index) in trainingDataAcquisition"
              :key="index"
            >
              <div class="cover">
                <img
                  :src="theDefaultImage(item.eduPrProject.cover)"
                  onerror="this.src='data:image/jpeg;base64,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'"
                />
              </div>
              <div class="info">
                <div class="project-title">
                  {{ item.eduPrProject.projectName }}
                </div>
                <div class="project-level">
                  <span class="incharge"
                    >负责人：<i> {{ item.eduPrProject.projectLeader }}</i></span
                  >
                </div>
                <div class="project-brief">
                  <span class="brief-title">项目简介：</span>
                  <div class="accordingTo" v-html="item.eduPrProject.introduction"></div>
                </div>
                <div class="btns">
                  <a
                    class="go-project btn"
                    @click="clickOnTheCourse(item.eduPrProject.id)"
                    >进入项目</a
                  ><span
                    class="rm-project btn"
                    @click="quitTheCourse(item.courseId, item.id)"
                    >退出选课</span
                  ><a
                    class="hide vote-project btn vote-project-3200 disabled"
                    marked="1"
                    style="display: inline-block"
                    >实验评价<i class="iconfont"></i>
                    <div class="btn-tip">
                      完成实验后才可进行评价，如已完成实验仍无法评价，可在5～10分钟后尝试刷新页面！
                    </div></a
                  ><span class="score-project btn" @click="myGrades(item.courseId)"
                    >我的成绩</span
                  >
                  <span class="score-project btn" @click="behaviorRecords(item.courseId)"
                    >行为记录</span
                  >
                </div>
              </div>
            </li>
            <div class="noitems" v-show="collectTheNumber == 0">暂无实验</div>
          </ul>

          <div
            id="dialog_overlay"
            style="visibility: visible"
            class=""
            v-show="resultsPopupDisplay == 4"
          >
            <div id="dialog_bg"></div>
            <div
              id="dialog_panel"
              class=""
              style="margin-left: -136px; margin-top: -61px"
            >
              <div id="dialog_panel_bg"></div>
              <div id="dialog_title" style="display: block">提示</div>
              <div id="dialog_content">是否确认要退出本项目的学习？</div>
              <div id="dialog_control">
                <a
                  href="javascript:void(0)"
                  id="dialog_close"
                  class="button"
                  style="display: inline-block"
                  marked="1"
                  @click="resultsPopupDisplay = 5"
                  >取消</a
                ><a
                  href="javascript:void(0)"
                  id="dialog_ok"
                  class="button"
                  marked="1"
                  style="display: inline-block"
                  @click="confirmTheDrop0((resultsPopupDisplay = 5))"
                  >确认</a
                >
              </div>
            </div>
          </div>

          <div v-show="resultsPopupDisplay == 1">
            <div id="c-panel-bg"></div>
            <div class="c-content" style="margin-top: -180px; margin-left: -410px">
              <div id="search" class="search" @click="clickOnClose()">
                <span class="close-cpanel"></span>
              </div>

              <div id="uList">
                <table class="m-hide">
                  <tbody>
                    <tr class="l_header">
                      <th class="itemTitle">实验项目</th>
                      <th class="itemCategory">实验结果</th>
                      <th class="itemTitle">实验成绩</th>
                      <th class="itemTitle">实验开始时间</th>
                      <th class="itemTitle">实验结束时间</th>
                      <th class="itemTitle">实验用时</th>
                      <th class="action" width="90">操作</th>
                    </tr>

                    <tr v-for="(item, index) in resultsData" :key="index">
                      <td class="itemStatus">
                        {{ item.title }}
                      </td>
                      <td class="itemStatus">完成</td>
                      <td class="itemStatus">{{ item.evaluation }}</td>
                      <td class="itemStatus">{{ item.startTime }}</td>
                      <td class="itemStatus">{{ item.endTime }}</td>
                      <td class="itemStatus">1</td>
                      <td class="action">
                        <a
                          class="set"
                          href="javascript:void(0)"
                          @click="checkTheDetails(item.originId)"
                          >查看详情</a
                        ><br /><a
                          class="set"
                          target="_blank"
                          @click="reportToDownload(item.originId)"
                          >下载报告</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="noData countlessAccordingTo" v-show="resultsTheNumberOf == 0">
                  暂无数据
                </div>
                <ul class="m-list m-show hide">
                  <li>
                    <p>子实验名称：超冷原子量子振荡跃迁虚拟仿真实验</p>
                    <p>实验结果：完成</p>
                    <p>实验成绩：0</p>
                    <p>实验开始时间：2022-05-16 10:21:42</p>
                    <p>实验结束时间：2022-05-16 10:22:21</p>
                    <p>实验用时：1</p>
                    <p>
                      实验报告：<a
                        class="set"
                        href="/oss_report_attachment/104417_1652667744546_62d68a856fd838dde25f1b53f145c155.doc"
                        target="_blank"
                        >下载报告</a
                      >
                    </p>
                  </li>
                </ul>
              </div>
              <!-- <ul class="cN-pagination" id="pagination1">
                <li class="selected">1</li>
                <span class="page_total">共<b>1</b>条</span
                ><span class="page_goto"
                  ><input
                    class="page"
                    id="page-num-gotoPage1"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                  /><span class="go-page" id="go-page-gotoPage1">GO</span></span
                >
              </ul> -->
            </div>
          </div>

          <div v-show="resultsPopupDisplays == 1">
            <div id="c-panel-bg"></div>
            <div class="c-content" style="margin-top: -180px; margin-left: -410px">
              <div id="search" class="search" @click="clickOnCloses()">
                <span class="close-cpanel"></span>
              </div>

              <div id="uList">
                <table class="m-hide">
                  <tbody>
                    <tr class="l_header">
                      <th class="itemTitle" width="200px">实验步骤</th>
                      <th class="itemCategory">操作分解</th>
                      <th class="itemTitle">操作时间</th>
                    </tr>

                    <tr
                      v-for="(item, index) in resultsDatas"
                      :key="index"
                      class="behaviorRecordStyle"
                    >
                      <td class="itemStatus">{{ item.activityName }}</td>
                      <td class="itemStatus">{{ item.activityDesc }}</td>
                      <td class="itemStatus">{{ item.createTime }}</td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="noData countlessAccordingTo"
                  v-show="resultsTheNumberOfs == 0"
                >
                  暂无数据
                </div>
              </div>
              <!-- <ul class="cN-pagination" id="pagination1">
                <li class="selected">1</li>
                <span class="page_total">共<b>1</b>条</span
                ><span class="page_goto"
                  ><input
                    class="page"
                    id="page-num-gotoPage1"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                  /><span class="go-page" id="go-page-gotoPage1">GO</span></span
                >
              </ul> -->
            </div>
          </div>

          <div v-show="resultsPopupDisplays == 3">
            <div id="c-panel-bg"></div>
            <div class="c-contents" style="margin-top: -180px; margin-left: -410px">
              <div id="search" class="search" @click="clickOnCloses()">
                <span class="close-cpanel close-cpanels"></span>
              </div>

              <div id="uList">
                <table class="m-hide">
                  <tbody>
                    <tr class="l_header">
                      <th class="itemTitle">步骤编号</th>
                      <th class="itemTitle">步骤名称</th>
                      <th class="itemTitle">实验步骤操作次数</th>
                      <th class="itemTitle">赋分模型</th>

                      <th class="itemCategory">开始时间</th>
                      <th class="itemTitle">结束时间</th>
                      <th class="itemTitle">合理用时</th>
                      <th class="itemTitle">实验用时</th>
                      <th class="itemTitle">百分制</th>
                      <th class="itemTitle">评价</th>
                      <th class="itemTitle">备注</th>
                    </tr>

                    <tr
                      v-for="(item, index) in detailsOfTheData"
                      :key="index"
                      class="behaviorRecordStyle"
                    >
                      <td class="itemStatus">{{ item.seq }}</td>
                      <td class="itemStatus">{{ item.title }}</td>
                      <td class="itemStatus">{{ item.repeatCount }}</td>
                      <td class="itemStatus">{{ item.scoringModel }}</td>

                      <td class="itemStatus">{{ time(item.startTime) }}</td>
                      <td class="itemStatus">{{ time(item.endTime) }}</td>
                      <td class="itemStatus">
                        {{ aVehicleConversion(item.expectTime) }}
                      </td>
                      <td class="itemStatus">{{ aVehicleConversion(item.timeUsed) }}</td>
                      <td class="itemStatus">{{ item.maxScore }}</td>
                      <td class="itemStatus">{{ item.evaluation }}</td>
                      <td class="itemStatus">{{ item.remarks }}</td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="noData countlessAccordingTo"
                  v-show="resultsTheNumberOfs == 0"
                >
                  暂无数据
                </div>
              </div>
              <!-- <ul class="cN-pagination" id="pagination1">
                <li class="selected">1</li>
                <span class="page_total">共<b>1</b>条</span
                ><span class="page_goto"
                  ><input
                    class="page"
                    id="page-num-gotoPage1"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                  /><span class="go-page" id="go-page-gotoPage1">GO</span></span
                >
              </ul> -->
            </div>
          </div>
          <!-- <ul id="pagination" class="cN-pagination">
            <li class="selected">1</li>
            <span class="page_total">共<b>2</b>条</span
            ><span class="page_goto"
              ><input
                class="page"
                id="page-num"
                onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
              /><span class="go-page" id="go-page">GO</span></span
            >
          </ul> -->
        </div>
      </div>

      <div id="c-panel">
        <div id="c-panel-bg"></div>
        <div class="c-content">
          <form id="search" class="search" onsubmit="return false;">
            <span class="close-cpanel"></span>
          </form>
          <div id="uList"></div>
          <ul class="cN-pagination" id="pagination1"></ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import {
  personalInformationQuery,
  afterTheLoginAccessPermissions,
  loginAccessToTheMenu,
  myTraining,
  quitTheCourseSelectionInterface,
  myGradesInterface,
  recordTheData,
  recordDetails,
  downloadTheReport,
} from "../assets/api/index";
import router from "../router/index.js";
import url from "../assets/js/config.js";
import { ElMessage } from "element-plus";
import { time, aVehicleConversion } from "../assets/utils/time.js";
export default {
  setup() {
    //我的实验
    const trainingDataAcquisition = ref();

    const tableData = ref([]);
    const theLoginRequest = reactive({
      userld: null,
    });
    const getStatusInformation = reactive([]);
    const provincialData = ref([]);
    const getData = () => {
      personalInformationQuery(theLoginRequest).then((res) => {
        tableData.value = res.user;
        // provincialData.value = JSON.parse(res.data.remark);

        // getStatusInformation.value = JSON.parse(res.data.remark).indexType;
      });
    };

    //我的实验获取
    const trainingRequestData = reactive({
      uid: localStorage.getItem("userId"),
      status: "y",
    });
    const collectTheNumber = ref([]);
    const automaticAccessToTraining = () => {
      myTraining(trainingRequestData).then((res) => {
        trainingDataAcquisition.value = res.rows;
        collectTheNumber.value = res.total;
        console.log(trainingDataAcquisition.value);
      });
    };
    automaticAccessToTraining();
    //登陆后获取权限
    const afterLandingPermissionData = ref([]);
    const automaticallyAccessPermissions = () => {
      afterTheLoginAccessPermissions().then((res) => {
        afterLandingPermissionData.value = res.user;
        theLoginRequest.userld = res.user.userId;
        getData();
      });
    };
    automaticallyAccessPermissions();

    //登陆后获取菜单

    const automaticAccessToTheMenu = () => {
      loginAccessToTheMenu().then((res) => {});
    };
    automaticAccessToTheMenu();

    //上传图片
    const handleRemove = (file, fileList) => {
      console.log(file, fileList);
    };

    const gender = (sex) => {
      if (sex == 0) {
        return "男";
      } else {
        return "女";
      }
    };

    //课程详情
    const clickOnTheCourse = (id) => {
      localStorage.setItem("tABWhich", 1);
      setTimeout(function () {
        location.reload();
      }, 50);

      localStorage.setItem("courseid", id);
      // router.push("/projectDetails");
      router.push({ path: "projectDetails", query: { courseid: id } });

      // localStorage.setItem("courseid", id);
      // router.push("/projectDetails");
    };

    //默认图片
    const theDefaultImage = (value) => {
      if (value == null) {
        return require("../assets/image/listmoren.jpg");
      } else {
        return url + value;
      }
    };

    //退出选课
    const forTheRequest = reactive({
      courseId: null,
      userId: localStorage.getItem("userId"),
      id: null,
    });
    const quitTheCourse = (value, id) => {
      resultsPopupDisplay.value = 4;
      forTheRequest.courseId = value;
      forTheRequest.id = id;
    };

    //确认退课
    const confirmTheDrop0 = () => {
      quitTheCourseSelectionInterface(forTheRequest).then((res) => {
        if (res.code == 500) {
          ElMessage.error(res.msg);
        } else {
          ElMessage.success(res.msg);
          automaticAccessToTraining();
        }
      });
    };
    //我的成绩
    const resultsPopupDisplay = ref(2);
    const resultsData = ref([]);
    const resultsTheNumberOf = ref([]);
    const myGrades = (value) => {
      forTheRequest.courseId = value;
      resultsPopupDisplay.value = 1;
      myGradesInterface(forTheRequest).then((res) => {
        resultsData.value = res.rows;
        resultsTheNumberOf.value = res.total;
        console.log(resultsTheNumberOf.value);
      });
    };

    //行为记录
    const resultsPopupDisplays = ref(2);
    const resultsDatas = ref([]);
    const resultsTheNumberOfs = ref([]);
    const behaviorRecords = (value) => {
      forTheRequest.courseId = value;
      resultsPopupDisplays.value = 1;
      recordTheData(forTheRequest).then((res) => {
        resultsDatas.value = res.rows;
        resultsTheNumberOfs.value = res.total;
        console.log(resultsTheNumberOfs.value);
      });
    };

    //成绩详情

    //点击关闭
    const clickOnClose = () => {
      resultsPopupDisplay.value = 2;
    };

    //点击关闭
    const clickOnCloses = () => {
      resultsPopupDisplays.value = 2;
    };

    //默认图显示
    const imageIsEmpty = (value) => {
      if (value == null || value == "") {
        return require("../assets/image/index.png");
      } else {
        return value;
      }
    };

    //查看详情
    const detailsAboutTheTransmission = reactive({
      originId: null,
    });
    const detailsOfTheData = ref([]);
    const checkTheDetails = (value) => {
      resultsPopupDisplays.value = 3;
      detailsAboutTheTransmission.originId = value;
      recordDetails(detailsAboutTheTransmission).then((res) => {
        detailsOfTheData.value = res.rows;
      });
    };

    //报告下载

    const reportToDownload = (value) => {
      detailsAboutTheTransmission.originId = value;
      downloadTheReport(detailsAboutTheTransmission).then((res) => {
        let fileUrl = res.rows[0].fileUrl;

        window.open(fileUrl);
      });
    };

    return {
      imageIsEmpty,
      clickOnClose,
      clickOnCloses,
      theDefaultImage,
      quitTheCourse,
      reportToDownload,
      myGrades,
      checkTheDetails,
      clickOnTheCourse,
      confirmTheDrop0,
      resultsTheNumberOf,
      behaviorRecords,
      resultsData,
      detailsOfTheData,
      resultsPopupDisplays,
      resultsPopupDisplay,
      collectTheNumber,
      trainingRequestData,
      forTheRequest,
      trainingDataAcquisition,
      tableData,
      afterLandingPermissionData,
      getStatusInformation,
      provincialData,
      url,
      resultsDatas,
      handleRemove,
      gender,
      automaticAccessToTheMenu,
      automaticallyAccessPermissions,
      automaticAccessToTraining,
      getData,
      time,
      aVehicleConversion,
    };
  },

  name: "teachersPersonalCenter",
};
</script>

<style src="../assets/css/jiaoshi/bootstrap-v3.3.7.min.css" scoped></style>
<style src="../assets/css/jiaoshi/common.css" scoped></style>
<style src="../assets/css/jiaoshi/common1.css" scoped></style>
<style src="../assets/css/jiaoshi/form.css" scoped></style>
<style src="../assets/css/jiaoshi/laydate.css" scoped></style>
<style src="../assets/css/jiaoshi/my-project-learn.css" scoped></style>
<style src="../assets/css/jiaoshi/header_v5.css" scoped></style>
<style src="../assets/css/jiaoshi/pagination.css" scoped></style>
<style src="../assets/css/jiaoshi/table.css" scoped></style>
<style src="../assets/css/dialog.css" scoped></style>

<style scoped>
.accordingTo {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
}
.noData.countlessAccordingTo {
  color: #d2d2d2;
}
.c-contents {
  background: #f9f9f9 none repeat scroll 0 0;
  height: 450px;
  left: 40%;
  margin-left: -290px;
  margin-top: -300px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 20px 10px;
  position: fixed;
  top: 50%;
  width: 1200px;
}
.close-cpanels {
  top: 22px !important;
}
</style>